import Swiper from "swiper";

const swiperContainer = document.querySelector(".swiper-container");
const planets = document.querySelectorAll(".planets__item");

let isEnter = false;

const toSelectActivePlanet = function() {
  if (!isEnter) return false;

  planets.forEach(planet => {
    planet.classList.remove("planets__item_current");
  });

  planets[planetsSlider.activeIndex].classList.add("planets__item_current");
};

const planetsSlider = new Swiper(swiperContainer, {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

planetsSlider.on("slideChange", () => {
  toSelectActivePlanet();
});

swiperContainer.addEventListener("mouseenter", () => {
  isEnter = true;

  planets[planetsSlider.activeIndex].classList.add("planets__item_current");
});

swiperContainer.addEventListener("mouseleave", () => {
  isEnter = false;

  planets.forEach(planet => {
    planet.classList.remove("planets__item_current");
  });
});
